import { getBrand } from '../../../../utils/getBrand';
import { getConnectingToAgentImage } from '../../../../utils/getConnectingToAgentImage';
import { ActionType, ComponentType, MessageType } from '../../../types/enum';

export function createLiveChatSystemMessage(
  messageTitle: string,
  messageSubtitle?: string,
  cannedResponseText?: string,
  withIcon?: boolean
): Message {
  const message: Message = {
    time: new Date(),
    messageType: MessageType.SYSTEM,
    messageComponent: {
      component: ComponentType.SystemMessageComponent,
      componentData: {
        messageTitle: messageTitle,
        cardText: messageSubtitle,
        isFullHeight: true,
      },
      actions: {
        onCannedResponseClick: ActionType.closeLiveChatConnection,
      },
    },
  };
  if (cannedResponseText && message.messageComponent?.componentData) {
    message.messageComponent.componentData.cannedResponses = [
      { value: cannedResponseText, canBeMuted: false },
    ];
  }
  if (withIcon && message.messageComponent?.componentData) {
    message.messageComponent.componentData.bigIcon = getConnectingToAgentImage(
      getBrand().code
    );
    message.messageComponent.componentData.rippleEffect = true;
  }
  return message;
}
